import styled from 'styled-components';
import { palette } from 'styled-theme';

export const RecentWrapper = styled('div')`
  display: flex;
  flex-direction: column;

  .recent-header {
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0px;
    color: ${palette('grayscale', 7)};
  }

  .recent-message {
    color: ${palette('globalSearch', 5)};
  }
`;
